import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Ticker from 'react-ticker'
import { retrieveDisclosure } from '../../Services/DisclosureApiService';
import { useAuthHeader } from '../../auth/AuthService';

export default function DisclosureScroller() {
    const {t, i18n} = useTranslation();
    const [disclosures, setDisclosures] = useState([]);
    const [disclosurekh, setDisclosurekh] = useState([]);
    const authHeader = useAuthHeader();

    async function getDisclosure() {
        await retrieveDisclosure('en', authHeader())
        .then((response) => {
            let data = response.data.data;
            setDisclosures(data);
        })
        .catch((error) => console.log(error))
        await retrieveDisclosure('kh', authHeader())
        .then((response) => {
            let data = response.data.data;
            setDisclosurekh(data);
        })
        .catch((error) => console.log(error))
    }

    useEffect(() => {
        getDisclosure();
    }, []);

    if (disclosures.length && disclosurekh.length) {
        return ( 
            <Ticker offset="run-in"> 
                {({ index }) => (
                    <span className='text-nowrap white-space-nowrap'>
                        {disclosures.map((d, i) => <span key={i}><span className='font-italic'>{disclosurekh[i]?.dtdcontents}</span> <span className='font-italic'>{d.dtdcontents}</span></span>)}
                    </span>
                )}
            </Ticker>
        )
    }
}